import styled from 'styled-components';

export const $Content = styled.div`
  flex: auto;
  height: 100%;
`;
